import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getCompetitorsQueryOptions } from '@/_pages/competitors/api-service';

export const Route = createFileRoute('/_private/competitors/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompetitorsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={6} />,
});
